import {
  type AudienceRulesTree,
  MediaDataRoomVersion,
  type RuleBasedAudience,
} from "features/mediaDataRoom/models";

export const replaceDecentriqOrgName = (
  orgName: string | undefined,
  replacement: string
): string => (orgName === "Decentriq" || !orgName ? replacement : orgName);

// Transforms data for UI purposes
export const formatBasePropensity = (basePropensity: number): string =>
  `${basePropensity}%`;
export const formatOverlapPropensity = (overlapPropensity: number): string =>
  `${overlapPropensity}%`;
export const formatNetPropensity = (netPropensity: number): string =>
  `${netPropensity}x`;

export const normalizeEmail = (email: string) => email.trim().toLowerCase();

// TODO: this should be removed after checking with Lorenzo that DCR with email case issue is not used anymore
export const isNormalizedEmailIncluded = (
  emails: (string | null | undefined)[],
  currentEmail: string
) =>
  emails.some(
    (email) => normalizeEmail(email || "") === normalizeEmail(currentEmail)
  );

export const mapRulesBasedAudienceToAudienceRulesTree = (
  { combine, filters, sourceRef, id }: RuleBasedAudience,
  namesByAudienceId: Record<string, string>
): AudienceRulesTree => ({
  combine: combine
    ? combine.map(({ operator, sourceRef, filters }) => ({
        filters: filters ?? undefined,
        name: namesByAudienceId[sourceRef] ?? sourceRef,
        operator,
        sourceRef,
      }))
    : null,
  filters: filters ?? undefined,
  id,
  name: namesByAudienceId[sourceRef] ?? sourceRef,
  sourceRef,
});

export const formatNumber = (number: number): string =>
  Intl.NumberFormat("de-DE", { notation: "standard" }).format(number);

export const getMediaDataRoomVersionedValue = <T>(
  version: MediaDataRoomVersion,
  { ab, v3 }: { ab: T; v3: T }
): T => {
  switch (version) {
    case MediaDataRoomVersion.ab:
      return ab;
    case MediaDataRoomVersion.v3:
      return v3;
  }
};
